import { UUID } from "uuid-generator-ts";
import { Ref } from "vue";
import { Store } from "vuex";

export const letterToPos = (letter: string): number => {
	const abc = "abcdefghijklmnopqrstuvwxyz";
	return abc.indexOf(letter.toLowerCase()) + 1;
};

export const getUUID = (): string => {
	const uuid = new UUID();
	const id = uuid.getDashFreeUUID();
	return id;
};

export const initFormFieldValue = (data: Ref<any>, store: Store<any>) => {
	const attrs = {
		key: data.value.name,
		field: { ...data.value },
	}
	store.commit("main/setFormData", attrs)
}

export const setFormFieldInitialErrorMsg = async (data: Ref<any>, store: Store<any>) => {
	if (data.value && data.value.initerrormsg) {
		await store.dispatch("main/handleValidatingError", { error: data.value.initerrormsg, field: data.value })
	}
}
